import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)
import hud from './hud.js';
import encrypt from './encrypt.js';
import user from './user.js';
import tool from './tool.js';
import uaService from './ua.js';
// 服务器地址
const root = (typeof window !== 'undefined' && window.__PRERENDER_INJECTED && process.env.NODE_PRERENDER_HOST)
  ? process.env.NODE_PRERENDER_HOST
  : process.env.NODE_HOST;
console.info('[http] root:', root)
// 设置网络请求根路径
Vue.http.options.root = root + 'api/user/';
// 网络请求
export default {
  /**
   * 成功状态码
   */
  statusCode: 200,

  /**
   * 服务器地址
   */
  base: root,

  /**
   * api地址
   */
  api: this.base + 'api/user/',

  /**
   * 图片地址
   */
  image: this.base + '',

  /**
   * 网络请求字典加密
   *
   * @param params 加密的字典
   */
  paramsMd5(params = {}, timestamp) {
    params = JSON.parse(JSON.stringify(params));
    const allKeys = Object.keys(params).sort();
    var sign = '';
    allKeys.forEach(key => {
      sign += key;
      sign += '=';
      sign += params[key] == undefined ? '' : tool.trim(params[key].toString());
      sign += '&';
    });
    sign += 'secret=4cnSvBx8b1WdX&timestamp=';
    sign += timestamp;
    return encrypt.md5(sign);
  },

  /**
   * 配置
   *
   * @param method 请求方式
   * @param scheme 链接
   * @param params 参数字典
   * @param printTitle 打印标题
   * @param loading 是否显示加载中
   * @param uploadProgress 上传进度
   * @param downloadProgress 下载进度
   */
  config(method, scheme, params, printTitle, loading, uploadProgress, downloadProgress) {
    params = params || {};
    //时间戳
    const date = new Date();
    const timestamp = (date.getTime() / 1000).toFixed(0);
    //加密
    const sign = this.paramsMd5(params, timestamp);
    return {
      params: method == 'UPLOAD' ? {} : params,
      headers: {
        'Accept': 'application/json',
        'X-Sign': sign,
        'X-Timestamp': timestamp,
        'X-User-Token': user.userToken(),
        'X-Client': 'user_pc',
        'X-Client-Version': uaService.clientOs() + '/' + uaService.getBrowser().type + '/' + uaService.getBrowser().versions,
        'content-type': ['', 'application/x-www-form-urlencoded', 'multipart/form-data'][
          ['GET', 'POST', 'UPLOAD'].indexOf(method)
          ]
      },
      responseType: 'json',
      emulateJSON: true, //Send request body as application/x-www-form-urlencoded content type
      timeout: method == 'UPLOAD' ? 60000 : 10000,
      before: res => {
        //开启刷新
        if (loading) hud.loading();
      },
      uploadProgress: res => {
        // if (uploadProgress) uploadProgress(res);
      },
      downloadProgress: res => {
        if (downloadProgress) downloadProgress(res);
      }
    };
  },

  /**
   * POST请求
   *
   * @param scheme 链接
   * @param params 参数字典
   * @param printTitle 打印标题
   * @param loading 是否显示加载中
   * @param errorHud 是否显示错误提示
   */
  post(scheme = '',
       params = {},
       printTitle = '',
       loading = true,
       errorHud = true
  ) {
    params = params || {};
    var config = this.config('POST', scheme, params, printTitle, loading);
    config.params = {};
    // this.config('POST', scheme, params, printTitle, loading)
    return new Promise((resolve, reject) => {
      Vue.http.post(scheme, params, config).then(response => {
        this.success(scheme, params, printTitle, loading, errorHud, response, resolve, reject);
      }, error => {
        this.failure(scheme, params, printTitle, loading, errorHud, error, reject);
      });
    });
  },

  /**
   * GET请求
   *
   * @param scheme 链接
   * @param params 参数字典
   * @param printTitle 打印标题
   * @param loading 是否显示加载中
   * @param errorHud 是否显示错误提示
   */
  get(scheme = '',
      params = {},
      printTitle = '',
      loading = true,
      errorHud = true
  ) {
    return new Promise((resolve, reject) => {
      Vue.http.get(scheme, this.config('GET', scheme, params, printTitle, loading)).then(response => {
        this.success(scheme, params, printTitle, loading, errorHud, response, resolve, reject);
      }, error => {
        this.failure(scheme, params, printTitle, loading, errorHud, error, reject);
      });
    });
  },

  /**
   * 上传文件
   *
   * @param scheme 链接
   * @param params 参数字典
   * @param file 文件
   * @param name 服务器接收参数名
   * @param loading 是否显示加载中
   * @param errorHud 是否显示错误提示
   */
  upload(scheme = '',
         params = {},
         file = new File(),
         name = '',
         loading = true,
         errorHud = true,
  ) {
    const printTitle = '上传文件';
    params = params || {};
    var formData = new FormData();
    formData.append(name, file);
    for (const key in params) {
      formData.append(key, params[key]);
    }
    var config = this.config(scheme, params, printTitle);
    config.headers = {
      'content-type': 'multipart/form-data'
    };
    return new Promise((resolve, reject) => {
      Vue.http.post(scheme, formData, this.config('UPLOAD', scheme, params, printTitle, loading, errorHud)).then(
        response => {
          this.success(scheme, params, printTitle, loading, errorHud, response, resolve, reject);
        }, error => {
          this.failure(scheme, params, printTitle, loading, errorHud, error, reject);
        });
    });
  },


  /**
   * 成功
   * @param scheme 链接
   * @param params 参数字典
   * @param printTitle 打印标题
   * @param loading 是否显示加载中
   * @param errorHud 是否显示错误提示
   * @param response 返回数据
   * @param resolve 成功回调
   * @param reject 错误回调
   */
  success(scheme = '',
          params = {},
          printTitle = '',
          loading = true,
          errorHud = true,
          response,
          resolve,
          reject) {
    //隐藏加载提示
    if (loading) hud.hideLoading();
    response = response.body;
    if (response.code == this.statusCode) {
      resolve(response);
    } else {
      if (response.code == '20035') {
        hud.alert(response.message, 'mineEnterprise')
      } else if (response.code == '20014' || response.code == '20015') {
        hud.alert(response.message, 'login')
        user.userLogout()
      }
      this.failure(scheme, params, printTitle, loading, errorHud, response, reject);
    }
  },

  /**
   * 失败
   *
   * @param scheme 链接
   * @param params 参数字典
   * @param printTitle 打印标题
   * @param loading 是否显示加载中
   * @param errorHud 是否显示错误提示
   * @param error 错误
   * @param reject 错误回调
   */
  failure(scheme = '',
          params = {},
          printTitle = '',
          loading = true,
          errorHud = true,
          error,
          reject) {
    //隐藏加载提示
    if (loading) hud.hideLoading();
    // if (errorHud) hud.alert(printTitle || error.message || '加载失败，请重试');
    if (errorHud) hud.alert(error.message || '加载失败，请重试');
    reject(error);
  },

//   /**
//    * 上传图片-单图
//    *
//    * @param file 文件
//    * @param params 参数字典
//    * @param loading 是否显示加载中
//    * @param errorHud 是否显示错误提示
//    */
  uploadImage(
    file = new FormData(),
    params = {},
    loading = true,
    errorHud = true,
  ) {
    return this.upload('basic/upImage', params, file, 'file', loading, errorHud);
  },

  uploadFile(
    file = new FormData(),
    params = {},
    loading = true,
    errorHud = true
  ) {
    return this.upload('basic/upFile', params, file, 'file', loading, errorHud);
  },
  uploadFile1(
    file = new FormData(),
    params = {},
    loading = true,
    errorHud = true
  ) {
    return this.upload('basic/upContract', params, file, 'file', loading, errorHud);
  },


  setCookie(name, value) {
    let exp = new Date();
    exp.setTime(exp.getTime() + 3 * 60 * 60 * 1000); // 三小时
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  },

  getCookie(name) {
    let arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
    if (arr != null) return unescape(arr[2]);
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/http.js